var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636",
    transform: "translate(-827 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_862",
    "data-name": "Ellipse 862",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(827 477)",
    fill: "#fce8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5648",
    "data-name": "Group 5648",
    transform: "translate(840 490)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28991",
    "data-name": "Path 28991",
    d: "M2,10C2,6.229,2,4.343,3.172,3.172S6.229,2,10,2h4c3.771,0,5.657,0,6.828,1.172S22,6.229,22,10s0,5.657-1.172,6.828S17.771,18,14,18H10c-3.771,0-5.657,0-6.828-1.172S2,13.771,2,10Z",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28992",
    "data-name": "Path 28992",
    d: "M16,22a8.5,8.5,0,0,0-8,0",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28993",
    "data-name": "Path 28993",
    d: "M12,14h.009",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28994",
    "data-name": "Path 28994",
    d: "M12,11V7",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenWall);
export default __webpack_public_path__ + "static/media/garden_wall.b48f66ecda770cf5a2fcb321a560073d.svg";
export { ForwardRef as ReactComponent };